import React from 'react';
import { etapas, steps } from '../data/content';
export function MechanismSection() {
  return <section className="w-full bg-petrol py-11 text-white sm:py-14 lg:py-16" aria-labelledby="protocolo" data-id="element-104" data-mp="hc6up45tyeup">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-105" data-mp="ceer3cvtp4ao">
        <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-106" data-mp="8cbf8n58rxov">
          Qué es SOS Veraz
        </p>
        <h2 id="protocolo" className="mt-2.5 font-display text-2xl font-extrabold leading-[1.1] tracking-tight sm:text-4xl" data-id="element-107" data-mp="150zj8fk4hkfa">
          Un mapa de acción en 3 movimientos
        </h2>

        {/* Mapa de acción */}
        <ol className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3" data-id="element-108" data-mp="va4wla2ysitb">
          {steps.map(step => <li key={step.number} className="rounded-xl bg-white/10 p-4 ring-1 ring-white/10" data-id="element-109" data-mp="1nssb26nggzlf">
              <div className="flex items-center gap-2.5" data-id="element-110" data-mp="1numvljutepoz">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-oro font-display text-sm font-bold text-navy" aria-hidden="true" data-id="element-111" data-mp="1j1ad7rgqbf4o">
                  {step.number}
                </span>
                <h3 className="font-display text-lg font-bold uppercase tracking-tight" data-id="element-112" data-mp="3u6bqwv311qiy">
                  {step.title}
                </h3>
              </div>
              <p className="mt-2 text-[14px] leading-snug text-white/75" data-id="element-113" data-mp="2ww9723d81k2">{step.text}</p>
            </li>)}
        </ol>

        {/* Las 6 etapas */}
        <h3 className="mt-9 font-display text-xl font-bold tracking-tight sm:text-2xl" data-id="element-114" data-mp="3q4q70ps2sbz9">
          Las 6 etapas del manual
        </h3>
        <ol className="mt-4 grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-115" data-mp="3b8sbn9pz7bo3">
          {etapas.map((etapa, i) => <li key={etapa.title} className="flex flex-col rounded-xl bg-petrol-dark p-4 ring-1 ring-white/10" data-id="element-116" data-mp="19fkqvkrlg1ut" data-mpi={i}>
              <span className="font-mono text-[11px] font-bold text-oro" data-id="element-117" data-mp="1edmjoxetnfjh">0{i + 1}</span>
              <span className="mt-0.5 font-display text-[17px] font-bold leading-tight" data-id="element-118" data-mp="1cytl1r56flbr">
                {etapa.title}
              </span>
              <span className="mt-auto pt-2 text-[13px] leading-snug text-white/70" data-id="element-119" data-mp="12z2ozl0ywy9k">
                {etapa.text}
              </span>
            </li>)}
        </ol>

        <p className="mt-5 rounded-xl bg-white p-5 text-[14px] leading-relaxed text-navy-soft sm:text-[15px]" data-id="element-120" data-mp="yzagf8bkqs47">
          <strong className="font-semibold text-navy" data-id="element-121" data-mp="1vpkqihm1mrkv">
            El objetivo no es prometerte que una deuda desaparece:
          </strong>{' '}
          es que sepas qué figura y qué procedimiento corresponde en tu caso. Todo se apoya en los
          derechos de acceso, rectificación, actualización y supresión previstos en la Ley 25.326.
        </p>
      </div>
    </section>;
}